// src/api_scripts/getauxcodes.js
import { fetchAllPages } from "../paginationUtils";

const getAuxCodes = async (auxcodesName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/auxiliary-code`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Aux Codes");
    console.log("Get Aux Codes API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Aux Codes:`, error);
    throw error;
  }
};

export default getAuxCodes;